import React from 'react';
import { useSelector } from "react-redux";

// Components
import { ConversationNotifications } from '../modules/conversation-notifications/conversation-notifications';

// Styles
import './chat-status-network-disconnected.scss';

// Store entities
import { getGlobalConfigState } from "../../../store/global-config/global-config.selectors";

export const ChatStatusNetworkDisconnected = () => {

  const { businessTerms } = useSelector(getGlobalConfigState);

  const workerId = localStorage.getItem('worker_id');

  return (<ConversationNotifications
    title={ 'Oops, something went wrong' }
    text={ `The connection was lost. Please try to connect the ${ businessTerms.Consultant } again.` }
    navigateAction={ `/expert/${ workerId }/history` }/>);
}
